export const MODAL_TYPES = {
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
};

export interface APIResponse {
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  message?: any;
}

export enum ProfileType{
  ADMIN = 'Admin',
  CUSTOMER = 'Customer',
  USER = 'User'
}
